import ImageOptimizer from '@/components/image-optimizer';
import { TheoryExamLicenseEntity } from '@/data/exam/exam.data';

interface Props {
  item: TheoryExamLicenseEntity;
}
export default function MobileLicenseCard({ item }: Props) {
  return (
    <div className="bg-bg-graylight flex w-full flex-col items-center justify-center rounded-2xl p-8">
      <div className="mb-7 flex flex-col items-center gap-2">
        <span className="text-level-2 typo-22 font-bold">
          {item.licenseType}
        </span>
        {item.subLicenseType && (
          <span className="typo-16 text-level-4 font-medium">
            {item.subLicenseType}
          </span>
        )}
      </div>
      <div className="relative mb-8 flex aspect-square w-[116px] items-center justify-center rounded-full bg-white">
        <ImageOptimizer
          src={item.iconUrl}
          alt={item.licenseType + ' icon'}
          width={92}
          height={70}
        />
      </div>
      <div className="mb-4 flex w-full items-center justify-between gap-5">
        <span className="text-font-grayblue typo-16 shrink-0 font-bold">
          합격기준
        </span>
        <span className="typo-18 text-level-2 text-end leading-snug font-semibold">
          {item.passingCriteria}
        </span>
      </div>
      <div className="mb-4 flex w-full items-center justify-between gap-5">
        <span className="text-font-grayblue typo-16 shrink-0 font-bold">
          시험자격
        </span>
        <span className="typo-18 text-level-2 text-end leading-snug font-semibold">
          {item.examEligibility}
        </span>
      </div>
      <div className="flex w-full items-center justify-between gap-5">
        <span className="text-font-grayblue typo-16 shrink-0 font-bold">
          수수료
        </span>
        <span className="typo-18 text-level-2 text-end leading-snug font-semibold">
          {item.fee.toLocaleString()}원
        </span>
      </div>
    </div>
  );
}
